export default {
    previousPage:'Previous page',
    confirm:'Confirm',
    sensorCheck:'Sensor check',
    batteryType:'Battery type',
    smartBattery:'Smart battery',
    nonIntelligentBattery:'Non intelligent battery',
    battery:'Battery',
    power:'Power',
    voltage:'Voltage',
    temperature:'Temperature',
    parachute:'Parachute',
    parachuteStatus:'Parachute self check status',
    selfTestFailed:'Self test failed',
    selfCheckPassed:'Self check passed',
    parachutingState:'Parachuting state',
    locked:'Locked',
    unlocked:'Unlocked',
    umbrellaOpened:'Umbrella opened',
    compass:'Compass',
    range:'Range',
    accelerometer:'Accelerometer',
    satellite:'Satellite',
    positioningAccuracy:'Positioning accuracy',
    positioningType:'Positioning type',
    positioning:'Location',
    noPositioning:'No positioning',
    poorPositioning:'Poor positioning',
    singlePointPositioning:'Single point positioning',
    differentialPositioning:'Differential positioning',
    floatingPointRelocation:'Floating point relocation',
    fixedUnposition:'Fixed unposition',
    radar:'Radar',
    front:'Front',
    after:'After',
    lower:'Lower',
    left:'Left',
    right:'Right',
    structuralInspection:'Structural inspection',
    input:'Input',
    structuralInspection1:'Check whether the actual pointing of the handpiece is consistent with the compass direction',
    structuralInspection2:'Check whether the installation direction of each propeller is correct',
    structuralInspection3:'Check whether the rotation direction and installation angle of each motor are correct',
    structuralInspection4:'Check whether the battery is firmly installed',
    structuralInspection5:'Check whether the connection between the body and the arm is tight without looseness',
    structuralInspection6:'Check whether the installation of each antenna is fastened without looseness',
    structuralInspection7:'Check whether the landing gear is firmly installed',
    structuralInspection8:'Check whether the parachute is installed',
    communicationCheck:'Communication check',
    dataLink:'Data link',
    dataLink1:'Indicates the connection status between UAV and server using T15 communication module',
    dataLink2:'Indicates the connection status between the UAV and the server using the external communication module',
    notConnected:'Not connected',
    connected:'Connected',
    notObtained:'Not obtained',
    mobileNetwork:'Mobile Network',
    mobileNetwork1:'Due to the regional restrictions of the IoT network card, the aircraft may not be able to access the Internet in Xinjiang, Tibet, Yunnan, Guangxi and other regions. The problem can be solved by replacing the local SIM card.',
    mobileNetwork2:'LTE links are easily affected by the real-time network environment of operators. For scenarios with high network requirements, it is recommended to use non IoT network cards.',
    mobileNetwork3:'The RSSI range is - 50~- 70. If it is less than this value, the network signal is poor.',
    surplus:'surplus',
    remoteControl:'Remote control',
    externalHandle:'External handle',
    configurationCheck:'Configuration check',
    flightMode:'Flight Mode',
    flightMode1:'Not flying',
    flightMode2:'Takeoff mode',
    flightMode3:'Landing pattern',
    flightMode4:'Return mode',
    flightMode5:'Original route return mode',
    flightMode6:'Homing mode',
    flightMode7:'Pointing mode',
    flightMode8:'Surround Mode',
    flightMode9:'Attitude mode',
    flightMode10:'Fixed height mode',
    flightMode11:'Fixed point mode',
    flightMode12:'Automatic route',
    flightMode13:'AB point mode',
    remoteControlHandType:'Remote control hand type',
    americanHand:'American hand',
    japaneseHand:'Japanese hand',
    chineseHands:'Chinese hands',
    remoteControlHight:'Remote control height limit',
    rcProtect:'Remote control out of control protection',
    noAction:'No action',
    hover:'Hover',
    straightReturn:'Straight return',
    directReturn:'Direct return',
    linkRunawayProtection:'Link runaway protection',
    RTKtakeoff:'No RTK takeoff allowed',
    notAllow:'Not allow',
    allow:'Allow',
    returnAltitude:'Return altitude',
    returnSpeed:'Homeward speed',
    returnDirection:'Return direction',
    headOrientation:'Head orientation',
    tailOrientation:'Tail orientation',
    lowPowerProtection:'Low power protection',
    level1Alarm:'Level 1 alarm',
    level2Alarm:'Level II alarm',
    acoustoOpticAlerting:'Audible and visual alarm',
    beelineReturn:'Straight return',
    originalReturn:'Return on the original route',
    land:'Land',
    parachuteDetection:'Parachute detection',
    close:'Close',
    open:'Open',
    loadCheck:'Load check',
    FPVimage:'FPV image',
    PTZpod:'PTZ pod',
    pager:'Pager',
    loudspeakerInspection:'Loudspeaker inspection',
    thrower:'Thrower',
    pitchControl:'Pitch control',
    courseControl:'Course control',
    zoomControl:'Zoom control',
    photoControl:'Photo control',
    startRecording:'Start recording',
    endRecording:'End recording',
    imageSwitching:'Image switching',
    targetSolution:'Target solution',
    zuo:'Left',
    you:'Right',
    whole:'Whole',
    danguang:'Visible light (single light)',
    shuangguang:'Visible light+infrared (dual light)',
    sanguang:'Visible light+infrared+laser (three lights)',
    notInstalled:'Not Installed',
    alreadyInstalled:'Already Installed',
    pleaseSelect:'Please select',
    airspaceInspection:'Airspace inspection',
    airspaceInspection1:'Whether the flight mission is reported',
    airspaceInspection2:'Whether the airspace application is passed',
    airspaceInspection3:'Whether the takeoff position or route of UAV crosses the no fly zone',
    airspaceInspection4:'Whether the takeoff position or route of UAV crosses the restricted area',
    airspaceInspection5:'Whether the takeoff position or route of UAV crosses the densely populated area',
    tip1:'No fly zone: Under no circumstances can aircraft take off or fly into this zone.',
    tip2:'The no fly zone is a closed coordinate area of infinite height formed by connecting the 12 coordinate points of the civil airport obstacle limit surface and tolerance buffer area published by the Civil Aviation Administration as the boundary points. The aircraft in this area is not allowed to unlock and take off. After the aircraft outside the area flies to the boundary, it is forced to stop flying, automatically lands, and sends alarm information to the equipment owner and the background.',
    tip3:'Flight restricted area: the area where the aircraft can take off or enter but the flight altitude is limited.',
    tip4:'The restricted flight area is a circle with a radius of 25km and the center of the runway as the center. The restricted height of the circular area, which does not intersect the restricted flight area, is 50m.',
    tip5:'Densely populated areas refer to areas such as towns, villages, busy roads or large open-air meeting places.',
    tip6:'The number of people in this area is large and concentrated. Please operate with caution if there is a large hidden danger in the flight in this area.',
    yes:'yes',
    no:'no',
    inspectionOverview:'Inspection Overview',
    signOut:'Sign out',
    save:'Preservation',
    savingSucceeded:'Saving succeeded',
    time:'Time Interval',
    times:'Time',
    inspectors:'Inspectors',
    phone:'Mobile Phone',
    inspectionTime:'Inspection Time',
    details:'Details',
    chinaTelecom:'China Telecom',
    chinaMobile:'China Mobile',
    chinaUnicom:'China Unicom',
    parachuteStatu:'Parachute Status',
    camera:'FPV Camera',
    exportPicture:'Export Picture',
    inspectionRecord:'Inspection record',
    tip_PCTR: 'Please check the remote control configuration',
}